const initialState = 1;
const types = ["user", "expert", "controller", "admin"];
export default function account_type(state = initialState, action) {
  if (action.type === "SET_ACCOUNT_TYPE") {
      return types[action.payload - 1];
  }
  return state;
}
